export default "__VITE_ASSET__dxeFo02X__"